
import { ServiceLandingPage } from "@/components/service/ServiceLandingPage";

const RoofingPage = () => {
  const features = [
    {
      title: "Roof Repairs",
      description: "Quick, effective repairs for leaks, storm damage, and wear"
    },
    {
      title: "Complete Roof Replacement",
      description: "Full roof replacement with quality materials and expert installation"
    },
    {
      title: "Roof Inspections",
      description: "Thorough assessments to identify potential issues"
    },
    {
      title: "Storm Damage Specialists",
      description: "Expertise in hail and wind damage repairs"
    },
    {
      title: "Insurance Claim Assistance",
      description: "Help navigating the insurance claim process for roof damage"
    }
  ];

  const processSteps = [
    {
      title: "Free Inspection",
      description: "Comprehensive roof evaluation to assess condition and needs"
    },
    {
      title: "Detailed Estimate",
      description: "Clear, itemized quote for all recommended work"
    },
    {
      title: "Quality Installation",
      description: "Professional roofers using industry-best practices"
    },
    {
      title: "Final Inspection",
      description: "Thorough review to ensure quality and completion"
    }
  ];

  const benefits = [
    {
      title: "Licensed & Insured",
      description: "Fully licensed contractors with comprehensive insurance coverage"
    },
    {
      title: "Warranty Protection",
      description: "Manufacturer and workmanship warranties for your peace of mind"
    },
    {
      title: "Local Expertise",
      description: "Knowledge of Oklahoma's weather challenges and building codes"
    },
    {
      title: "Quality Materials",
      description: "Premium roofing products from trusted manufacturers"
    },
    {
      title: "Property Protection",
      description: "Careful work practices to protect your home during the project"
    }
  ];

  return (
    <ServiceLandingPage
      title="Roofing Services in Oklahoma City"
      metaDescription="Professional roofing services in Oklahoma City. Expert repairs, replacements, and storm damage restoration."
      introText="Connect with Oklahoma City's top-rated roofing contractors for reliable repairs, replacements, and maintenance."
      features={features}
      processSteps={processSteps}
      benefits={benefits}
      ctaText="Need roofing services in OKC?"
      ctaButtonText="Get Connected"
      contactText="Fill out the form below to connect with top-rated roofers in OKC."
    />
  );
};

export default RoofingPage;
